//Componentes generales
import React, { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import ProductList from "../../components/ProductList/ProductList";

//Context
import productsContext from "../../context/productos/productsContext";
import authContext from '../../context/authentication/authContex';

// Alertas
import Swal from 'sweetalert2'

//Estilos
import './Product.css';
import { VER_PRODUCTOS } from '../../utils/permisos';

//Iconos
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";

function Product(props) {

    //Context Auth
    const aContext = useContext(authContext);
    const { usuario } = aContext;

    //Context Add
    const pContext = useContext(productsContext);
    const { products, isCargando, actualizarProducts, actualizarProductsDB } = pContext;

    const navigate = useNavigate();

    useEffect(() => {
        const fn = async () => {
            await actualizarProducts();
        }
        fn();
    }, []);

    const handleBack = () => {
        navigate("/abms");
    };

    const handlerActualizarProductos = async () => {
        Swal.fire({
            title: 'Desea actualizar la lista de productos?',
            text: "Se traeran los datos de Softland para sobreescribir la base de datos de la aplicación.",
            showCancelButton: true,
            confirmButtonText: 'Actualizar',
            cancelButtonText: 'No, cancelar',
            showLoaderOnConfirm: true,
            preConfirm: async () => {
              return await actualizarProductsDB()
                .then(response => {
                  if (!response.status) {
                    throw new Error(response.msg)
                  }
                  return response;
                })
                .catch(error => {
                  Swal.showValidationMessage(`Request failed: ${error}`)
                })
            },
            allowOutsideClick: () => !Swal.isLoading()
          }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire('Actualizado!', 'La base de datos ha sido actualizada correctamente.', 'success')
            }
          })
    }

    return (
        <div className="container-list">
            <div className="back-button-container">
                <button className="back-btn" onClick={handleBack}>
                    <FontAwesomeIcon icon={faArrowLeft} style={{ marginRight: "5px" }} />
                </button>
            </div>
            {usuario.userType.some(item => VER_PRODUCTOS.includes(item.typeName)) && (
                <div className="actualiza-productos-container">
                    <button className="actualizar-productos-btn" onClick={handlerActualizarProductos}>Actualizar Productos</button>
                </div>
            )}
            <ProductList productos={products} cargando={isCargando} />
        </div>
    );
}

export default Product
